import { getLockedActionKeysForRow } from '../../types/ActionLockState';
import { selectActionLocks } from '../createEagGridStore';
import { useEagGridSelector } from '../useEagGridSelector';

/**
 * Returns a Set of action keys that are currently locked for the given row.
 *
 * Subscribes to the `actionLocks` slice of the store.
 * Used by RowActions to determine per-button disabled state.
 */
export function useActionLocksForRow(rowId: string): Set<string> {
  const actionLocks = useEagGridSelector(selectActionLocks);
  return getLockedActionKeysForRow(actionLocks, rowId);
}